import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
import { PHONE_VALIDATION_REGEXP } from '../../../constants/regexp';
export var PHONE_FIELD = {
  field: {
    label: 'Телефон',
    name: EFormFieldsNames.Phone,
    type: EExtendedFieldTypes.MaskedInputField,
    mask: '{+7 (}000{) }000{-}00{-}00',
    placeholder: '+7'
  },
  validation: yup.string().matches(PHONE_VALIDATION_REGEXP, 'Введите корректный номер телефона').required('Введите номер телефона')
};